import type { ReactNode } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { founder, LOGO } from '../../data/content';
import { shopHref } from '../../utils/hosts';
import { ease } from '../../core/format/motion';
type Props = {
  children: ReactNode;
  wide?: boolean;
};

/** Het kader van inloggen, de tweede stap en 2FA instellen: foto links, één kolom rechts. */
export function AuthShell({
  children,
  wide = false
}: Props) {
  const reduce = useReducedMotion();
  return <div className="admin-root grid min-h-screen min-h-dvh w-full bg-sand lg:grid-cols-2" data-id="element-3992" data-mp="1x6alit59eru5">
      <div className="relative hidden overflow-hidden lg:block" data-id="element-3993" data-mp="1x8mx8okfc5yr">
        <img src={founder.atWork} alt="" width={800} height={1000} decoding="async" className="absolute inset-0 h-full w-full object-cover" data-id="element-3994" data-mp="2b5jogr4gfpg6" />
        <div className="absolute inset-0 bg-ink/35" aria-hidden="true" data-id="element-3995" data-mp="gs2btz5l8czx" />
        <p className="absolute bottom-10 left-10 right-10 max-w-md font-display text-3xl font-light leading-snug text-shell" data-id="element-3996" data-mp="gu4x65vsphyb">
          Alles van je salon en webshop op één plek.
          <span className="italic" data-id="element-3997" data-mp="3g79nivqqd14h"> Zonder technische kennis.</span>
        </p>
      </div>

      <main className="flex items-center justify-center px-6 py-12" data-id="element-3998" data-mp="3l5kwl497b7ln">
        <motion.div initial={reduce ? false : {
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.25,
        ease
      }} className={`w-full ${wide ? 'max-w-md' : 'max-w-sm'}`} data-id="element-3999" data-mp="3q3cm5rmdihmo">
          <div className="flex items-center gap-3" data-id="element-4000" data-mp="2qaf2lakc6ey">
            <img src={LOGO} alt="Beauty Bewust" className="h-11 w-auto mix-blend-multiply" data-id="element-4001" data-mp="7pdhrz32m0jr" />
            <span className="rounded-full bg-ink px-2 py-0.5 text-[11px] text-shell" data-id="element-4002" data-mp="cp9d79xpcjnp">Beheer</span>
          </div>
          {children}
          <a href={shopHref('/')} className="mt-6 inline-block text-[13px] text-muted hover:text-ink" data-id="element-4003" data-mp="hmrmx2jjn2wr">
            <span aria-hidden="true" data-id="element-4004" data-mp="2eho06nf3seaz">← </span>Terug naar de website
          </a>
        </motion.div>
      </main>
    </div>;
}